import { render, staticRenderFns } from "./ni-icon-x.vue?vue&type=template&id=6f217c6c"
import script from "./ni-icon-x.vue?vue&type=script&lang=js"
export * from "./ni-icon-x.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports